module.exports = __webpack_public_path__ + "img/as.5d5e4323.svg";